import { render, staticRenderFns } from "./interest.vue?vue&type=template&id=3c0067b5&"
import script from "./interest.vue?vue&type=script&lang=js&"
export * from "./interest.vue?vue&type=script&lang=js&"
import style0 from "./interest.vue?vue&type=style&index=0&id=3c0067b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports